/** Datagrid key base — full key is `${EMPLOYEE_EXITS_DATAGRID_KEY}_${organizationId}` */
export const EMPLOYEE_EXITS_DATAGRID_KEY = "employee_exits_grid";
